<div class="px-6 py-4">
  <div class="flex justify-between items-center mb-4">
    <h1 class="text-2xl font-bold text-gray-800">
      {{ isEdit ? 'Editar entrada' : 'Nova entrada de materiais' }}
    </h1>
    <p-button label="Voltar" icon="pi pi-arrow-left" severity="secondary" (click)="goBack()"></p-button>
  </div>

  <p-card>
    <form [formGroup]="form">
      <p-stepper [(value)]="activeStep" [linear]="false" class="stepper-buttons-only">
        <p-step-list>
          <p-step [value]="1">Principal</p-step>
          <p-step [value]="2">Produtos</p-step>
          <p-step [value]="3">Pagamento</p-step>
          <p-step [value]="4">Total</p-step>
        </p-step-list>
        <p-step-panels>
          <p-step-panel [value]="1">
            <ng-template pTemplate="content">
              <div class="flex flex-col max-h-[calc(100vh-240px)] min-h-0">
                <div class="flex-1 min-h-0 overflow-y-auto py-4" [formGroup]="form">
                  <app-step-principal
                    [formGroup]="principalGroup"
                    [supplierOptions]="supplierOptions"
                    (requestNewSupplier)="goToNewSupplier()"
                  ></app-step-principal>
                </div>
                <div class="shrink-0 flex justify-end gap-2 pt-4 pb-2 border-t border-gray-200 bg-white mt-4">
                  <p-button label="Próximo" icon="pi pi-arrow-right" iconPos="right" (click)="goNext()"></p-button>
                </div>
              </div>
            </ng-template>
          </p-step-panel>
          <p-step-panel [value]="2">
            <ng-template pTemplate="content">
              <div class="flex flex-col max-h-[calc(100vh-240px)] min-h-0">
                <div class="flex-1 min-h-0 overflow-y-auto py-4" [formGroup]="form">
                  <app-step-produtos
                    [parentForm]="form"
                    [productOptions]="productOptions"
                    (filterChange)="onProductFilter($event)"
                    (requestNewProduct)="goToNewProduct()"
                  ></app-step-produtos>
                </div>
                <div class="shrink-0 flex justify-between pt-4 pb-2 border-t border-gray-200 bg-white mt-4">
                  <p-button label="Anterior" icon="pi pi-arrow-left" severity="secondary" (click)="goPrev()"></p-button>
                  <p-button label="Próximo" icon="pi pi-arrow-right" iconPos="right" (click)="goNext()"></p-button>
                </div>
              </div>
            </ng-template>
          </p-step-panel>
          <p-step-panel [value]="3">
            <ng-template pTemplate="content">
              <div class="flex flex-col max-h-[calc(100vh-240px)] min-h-0">
                <div class="flex-1 min-h-0 overflow-y-auto py-4" [formGroup]="form">
                  <app-step-pagamento
                    [parentForm]="form"
                    [typePaymentOptions]="typePaymentOptions"
                  ></app-step-pagamento>
                </div>
                <div class="shrink-0 flex justify-between pt-4 pb-2 border-t border-gray-200 bg-white mt-4">
                  <p-button label="Anterior" icon="pi pi-arrow-left" severity="secondary" (click)="goPrev()"></p-button>
                  <p-button label="Próximo" icon="pi pi-arrow-right" iconPos="right" (click)="goNext()"></p-button>
                </div>
              </div>
            </ng-template>
          </p-step-panel>
          <p-step-panel [value]="4">
            <ng-template pTemplate="content">
              <div class="flex flex-col max-h-[calc(100vh-240px)] min-h-0">
                <div class="flex-1 min-h-0 overflow-y-auto py-4" [formGroup]="form">
                  <app-step-total [formGroup]="totalGroup"></app-step-total>
                </div>
                <div class="shrink-0 flex justify-between pt-4 pb-2 border-t border-gray-200 bg-white mt-4">
                  <p-button label="Anterior" icon="pi pi-arrow-left" severity="secondary" (click)="goPrev()"></p-button>
                  <p-button
                    [label]="isEdit ? 'Salvar' : 'Cadastrar'"
                    icon="pi pi-check"
                    (click)="submit()"
                    [loading]="saving"
                    [disabled]="saving"
                  ></p-button>
                </div>
              </div>
            </ng-template>
          </p-step-panel>
        </p-step-panels>
      </p-stepper>
    </form>
  </p-card>
</div>
